import React, { useState, useEffect } from "react";
import Snackbar from "../../../../components/snackbar/snackbar";
import CSVExport from "../../../../components/csvExport";
import ConfirmDialog from "../../../../components/actionDialogs/confirmDialog";
import CustomTable from "../../../../components/table/table";
import "./view.css";
import { institutions_list, super_insti_delete } from "../../admin.api";
import Loader from "../../../../components/loader/loader";
import jwtDecode from "jwt-decode";
import moment from "moment";
import * as XLSX from "xlsx";

export default function View(props) {
  const [data, setdata] = useState([]);
  const [view, setView] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const handleEventList = () => {
    setIsActive(true);
    institutions_list().then((res) => {
      let tdata = res.data;
      tdata.forEach((item, index) => {
        item["slno"] = index + 1;
      });
      setdata(tdata);
      setIsActive(false);
    });
  };
  useEffect(() => {
    handleEventList();
  }, []);

  const handleView = (data) => {
    let path = "/academicinstitution-view/" + data.id;
    props.history.push(path);
  };
  const handleAddNew = () => {
    let path = "/institution-add";
    props.history.push(path);
  };
  async function fetchExportData() {
    const exportdata = [];
    data.forEach((item, i) => {
      exportdata.push({
        "sl no": i + 1,
        "Application No": item.unique_application_ref_no,
        "Institution Name": item.institution_name,
        "Name and Designation of Authorized Person with contact details":
          item.contact_person_details,
        "Registered Office Address": item.address,
        "Contact No": item.phone_no,
        "Contact Email Id": item.email,
        "Headquarter Details": item.headquaters_detail,
        "Date of Registration with KSpace": item.created_at
          ? moment(item.created_at).format("DD-MMM-YYYY hh:mm A")
          : "--",
        "Date of Approval": item.approved_at
          ? moment(item.approved_at).format("DD-MMM-YYYY hh:mm A")
          : "--",
        Status:
          item.approval_status == 0
            ? "Pending"
            : item.approval_status == 1
              ? "Requested"
              : item.approval_status == 2
                ? "Approved"
                : item.approval_status == 5
                  ? "Reverted"
                  : item.approval_status == 3
                    ? "SA Reverted"
                    : item.approval_status == 4
                      ? "Rejected"
                      : "",
      });
    });
    return exportdata;
  }
  const handleEdit = (row) => {
    let path = `/academic-edit/${row.id}`;
    props.history.push(path);
  };

  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleDownload = () => { };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };

  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    super_insti_delete(data.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleEventList();
    }
  };
  const downloadExcel = async () => {
    const exportData = await fetchExportData();

    if (!exportData.length) {
      setSnackMessage("No data available for download.");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Institutions");

    XLSX.writeFile(workbook, "Institutions.xlsx");
  };
  return (
    <div>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <Loader open={isActive} />
      <div className="view-container">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="m-0">
            <b>Applications</b>
          </h6>
          <button
            className="px-2 py-2 search-style border-0 text-white rounded"
            onClick={downloadExcel}
          >
            Download Excel
          </button>
        </div>
        <hr />
        {/* --------------admin----- */}

        <CustomTable
          {...props}
          columns={[
            { title: "Institution Name", field: "institution_name" },
            { title: "Application No", field: "unique_application_ref_no" },
            {
              title: "Date of Registration",
              field: "registration_date",
              type: "date",
            },
            { title: "Headquarters", field: "headquaters_detail" },
            {
              title: "Status",
              field: "approval_status",
              type: "regstatusType",
            },
          ]}
          data={data}
          actions={
            adminType === 2
              ? [
                { type: "view", handleClick: handleView },

                { type: "delete", handleClick: handleDelete },
              ]
              : [
                { type: "view", handleClick: handleView },
                { type: "edit", handleClick: handleEdit },

                // { type: "delete", handleClick: handleDelete },
              ]
          }
        // handleDownload={handleDownload}
        />
      </div>

      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Academic Institution ?"
          data={activeData}
          message="Are you sure to delete this Institution?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
